export function debounced(delay, fn) {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
}

export function handleLocalDevUrl(url) {
  let localPrefix = 'http://localhost:8000';
  if (
    window.location.host === 'localhost:5000' &&
    url.indexOf(localPrefix) === -1
  ) {
    url = `${localPrefix}${url}`;
  }
  return url;
}

export async function get(url, authToken) {
  url = handleLocalDevUrl(url);

  let token = authToken;
  let headers = {};
  if (!token) {
    token = getSetting('jwt');
  }

  if (token) {
    headers = {
      Authorization: 'JWT ' + token,
    };
  }
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });

  return resp;
}

export function abortableGet(options = {}) {
  const controller = new AbortController();
  const signal = controller.signal;
  const method = 'GET';

  let token = getSetting('jwt');
  let headers = {};

  if (token) {
    headers = {
      Authorization: 'JWT ' + token,
    };
  }

  return {
    abort: () => controller.abort(),
    fetch: (url) => {
      url = handleLocalDevUrl(url);
      return fetch(url, { ...options, method, signal, headers });
    },
  };
}

export async function post(url, jsonData, jwt) {
  url = handleLocalDevUrl(url);
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  let token = jwt;
  if (!token) {
    token = getSetting('jwt');
  }

  if (token) {
    headers['Authorization'] = `JWT ${token}`;
  } else {
    headers['X-CSRFToken'] = getCsrfToken();
  }
  const setting = {
    method: 'POST',
    headers,
    body: JSON.stringify(jsonData),
  };

  const response = await fetch(url, setting);

  return response;
}

export async function submit(url, method, data, jwt, isMultiPart) {
  url = handleLocalDevUrl(url);
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  let token = jwt;
  if (!token) {
    token = getSetting('jwt');
  }

  if (token) {
    headers['Authorization'] = `JWT ${token}`;
  } else {
    headers['X-CSRFToken'] = getCsrfToken();
  }

  if (isMultiPart) {
    delete headers['Content-Type'];
    delete headers['Accept'];
  }

  const setting = {
    method: method,
    headers,
    body: isMultiPart ? data : JSON.stringify(data),
  };

  const response = await fetch(url, setting);

  return response;
}

export function setSetting(key, value) {
  if (typeof Storage !== 'undefined') {
    localStorage.setItem(key, value);
  } else {
    // Sorry! No Web Storage support..
  }
}

export function getSetting(key) {
  return localStorage.getItem(key);
}

export function setSettingObject(key, value = {}) {
  setSetting(key, JSON.stringify(value));
}

export function getSettingObject(key) {
  return JSON.parse(getSetting(key) || '{}');
}

export function updateSettingObject(key, value = {}) {
  setSettingObject(key, { ...getSettingObject(key), ...value });
}

export function getCsrfToken() {
  let token =
    typeof Cookies == typeof undefined ? '' : Cookies.get('csrftoken');

  if (!token) {
    const tokenInput = document.getElementsByName('csrfmiddlewaretoken')[0];
    if (tokenInput) {
      token = tokenInput.value;
    }
  }

  return token;
}

export function secondToHour(seconds) {
  /*
        Converts a duration provided in seconds to:

            a) hh:mm:ss (no zero-padding for hours)
            or
            b) If hours < 1, mm:ss.
     */

  const format = (val) => `0${Math.floor(val)}`.slice(-2);
  const hours = seconds / 3600;
  const minutes = (seconds % 3600) / 60;

  const formattedMinutesAndSeconds = [minutes, seconds % 60].map(format);
  let formattedDurationString = '';

  if (hours >= 1) {
    const hoursMinutesSeconds = [hours]
      .map((val) => `${Math.floor(val)}`.slice(-2))
      .concat(formattedMinutesAndSeconds);
    formattedDurationString = hoursMinutesSeconds.join(':');
  } else {
    formattedDurationString = formattedMinutesAndSeconds.join(':');
  }

  return formattedDurationString;
}

export function updateUrlParam(key, value) {
  let queryString = window.location.search;
  let params = new URLSearchParams(queryString);

  if (params.has(key)) {
    if (params.get(key) !== value) {
      params.set(key, value);
    }
  } else {
    params.append(key, value);
  }

  const newUrl = `${window.location.protocol}//${window.location.host}${
    window.location.pathname
  }?${params.toString()}`;
  window.history.pushState({ path: newUrl }, '', newUrl);
}

export function getUrlParam(key) {
  let queryString = window.location.search;
  let params = new URLSearchParams(queryString);
  if (params.has(key)) {
    return params.get(key);
  }
}

export function buildUrl(base, params) {
  if (params) {
    const qs = Object.entries(params)
      .reduce((q, [key, value]) => [...q, `${key}=${value}`], [])
      .join('&');
    return base + (base.includes('?') ? '' : '?') + qs;
  }
  return base;
}

export function buildElementIdFromRowId(rowId) {
  return ''.concat('row_id_', rowId);
}

export function buildElementIdFromPageNumber(pageNum) {
  return ''.concat('page_id_', pageNum);
}
